import {AuthApiService} from "../auth/auth-api.service";
import {CustomerInstanceData, CustomerInstanceFeaturesData} from "./customer-instance.data";
import {Injectable} from "@angular/core";
import {CustomerInstanceVenueData} from "../customer-instance-venue/customer-instance-venue.data";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class CustomerInstanceService {

    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getCustomerInstance(id: string): Promise<CustomerInstanceData> {
        return firstValueFrom(this.http.get<CustomerInstanceData>("/fonzie/customer-instance/" + id, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createCustomerInstance(customerInstance: CustomerInstanceData): Promise<CustomerInstanceData> {
        return firstValueFrom(this.http.post<CustomerInstanceData>("/fonzie/customer-instance", customerInstance, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async updateCustomerInstance(id: string, clientId: string, instanceGroupId: string, brand: string): Promise<void> {
        return firstValueFrom(this.http.put<void>("/fonzie/customer-instance/" + id, {clientId: clientId, instanceGroupId: instanceGroupId, brand: brand}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstances(type: string): Promise<CustomerInstanceData[]> {
        return firstValueFrom(this.http.get<CustomerInstanceData[]>("/fonzie/customer-instance?type=" + type, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstancesByClientId(clientId: string): Promise<CustomerInstanceData[]> {
        return firstValueFrom(this.http.get<CustomerInstanceData[]>("/fonzie/customer-instance?clientId=" + clientId, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstanceVenues(customerInstanceId: string): Promise<CustomerInstanceVenueData[]> {
        return firstValueFrom(this.http.get<CustomerInstanceVenueData[]>("/fonzie/customer-instance/" + customerInstanceId + "/venues", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerInstanceFeatures(id: string): Promise<CustomerInstanceFeaturesData> {
        return firstValueFrom(this.http.get<CustomerInstanceFeaturesData>("/fonzie/customer-instance-features/" + id, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async saveCustomerInstanceFeatures(features: CustomerInstanceFeaturesData): Promise<CustomerInstanceFeaturesData> {
        return firstValueFrom(this.http.post<CustomerInstanceFeaturesData>("/fonzie/customer-instance-features", features, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
